import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

export type BkCardShadow = 'none' | 'subtle' | 'simple';

@Component({
  selector: 'bk-card',
  templateUrl: './bk-card.component.html',
  styleUrls: ['./bk-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BkCardComponent {
  @Input() shadow: BkCardShadow = 'simple';

  get classes(): string {
    return `bk-card bk-card--shadow-${this.shadow}`;
  }
}
